export default __webpack_public_path__ + "assets/images/15b00e6b4c0206805c2893df2947d7cb.svg";